import type { CisVerificationResult, Registration } from '@pgs/shared';

// A single draft state that covers both CIS and non-CIS forms. At submission time we
// select the correct branch of the discriminated union based on `occupation.cis`.
export type RegistrationDraft = {
  cis: boolean;
  personal: Partial<Registration['personal']>;
  referral: { hasCode?: 'yes' | 'no'; code?: string };
  agency: Partial<Registration['agency']>;
  bank: Partial<Registration['bank']>;
  occupation: Partial<Registration['occupation']> & { cis: boolean };
  utr?: { mode: 'enter' | 'na'; number?: string };
  payment: { situation?: 'a' | 'b' | 'c' };
  documents: {
    photoId?: { type: string; objectKey: string };
    proofAddress?: { type: string; objectKey: string };
    rightToWork?: { type: string; objectKey: string };
    niProof?: { type: string; objectKey: string };
    nameChange?: Array<{ type: string; objectKey: string }>;
    evisa?: {
      shareCode: string;
      dob: string;
      passed: boolean;
      details?: Record<string, unknown>;
      checkedAt: string;
    };
  };
  cisAssessment?: Record<string, unknown>;
  // CIS HMRC verification. entityType/companyName drive the verify call (a sole trader uses
  // their personal name); only `result` is submitted with the registration. Verification is
  // optional — an applicant can submit unverified (treated as 30%).
  cisVerification?: {
    entityType?: 'soleTrader' | 'company';
    companyName?: string;
    result?: CisVerificationResult;
  };
  declarationAccepted: boolean;
};

export const emptyDraft = (): RegistrationDraft => ({
  cis: false,
  personal: {},
  referral: {},
  agency: {},
  bank: {},
  occupation: { cis: false },
  payment: {},
  documents: {},
  declarationAccepted: false,
});
